// The flow SHAPE the compiler emits, plus the one helper that writes a route
// branch condition. A LEAF: it imports nothing, so every other compiler file —
// and `bot-config/orchestrator-scaffold.ts`, which re-exports all of it under
// its original names — can depend on it without an import cycle.
//
// These declarations MOVED here from `bot-config/orchestrator-scaffold.ts` when
// the emitter became the process compiler (Process-Compiled Agent, Wave 2).
// Nothing about them changed, and the scaffold re-exports every symbol, so
// `@vysto/shared/bot-config/orchestrator-scaffold` keeps the exact surface its
// consumers import today.
//
// PURE + web-safe: no React, no DB, no node builtins.

export type StarterNodeType =
  | 'msg'
  | 'ask'
  | 'act'
  | 'dec'
  | 'answer'
  | 'route'
  | 'call'
  | 'handoff'
  | 'fin'

export interface StarterNode {
  id: string
  type: StarterNodeType
  position?: { x: number; y: number }
  config: Record<string, unknown>
}

export interface StarterEdge {
  from: string
  to: string
  when?: string
  label?: string
}

export interface StarterFlow {
  nodes: StarterNode[]
  edges: StarterEdge[]
}

/** Sentinel key for a route's "any other case" default branch. */
export const DEFAULT_BRANCH = '__default__'

/** Build the route-branch condition for an intent (or the default branch). */
export function whenForIntent(routeVar: string, intent: string): string {
  return intent === DEFAULT_BRANCH ? 'true' : `vars.${routeVar} == "${intent}"`
}
